import { render, staticRenderFns } from "./FormSwitch.vue?vue&type=template&id=bbc8eb38&scoped=true"
import script from "./FormSwitch.js?vue&type=script&lang=js&external"
export * from "./FormSwitch.js?vue&type=script&lang=js&external"
import style0 from "./FormSwitch.scss?vue&type=style&index=0&id=bbc8eb38&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc8eb38",
  null
  
)

export default component.exports